import React, { useEffect } from "react";
import { StyledError } from "./style";
import { Icon } from "components/icon/Icon";
import useErrorStore from "stores/useErrorStore";
import { Button } from "components/button/Button/Button";
import { Logos } from "contents/logos";

interface ErrorAlertProps {
  /** Alert 타이틀 */
  title: string;
  /** description - <></> 혹은 <React.Fragment></React.Fragment>로 감쌀것 */
  children: React.ReactNode;
  /** 표시될 에러 코드명 */
  errorCode?: string | number;
  /** 버튼에 표시될 이름 */
  buttonTitle?: string;
  /** 버튼 클릭 메소드 */
  onClick?: () => void;
}

export const ErrorAlert = ({
  title,
  children,
  errorCode,
  buttonTitle,
  onClick,
}: ErrorAlertProps) => {
  const { setErrorCode } = useErrorStore();
  useEffect(() => {
    return () => setErrorCode(null);
  }, []);
  return (
    <StyledError>
      <div className="error-container">
        <div className="box">
          <div className="top">
            <div className="logo">
              <Logos.symbolLogo />
            </div>
            <div className="main">
              <div className="title-box">
                <Icon icon="AlertCircle" size={32} stroke="--pri-blue-9" />
                <p className="title">{title}</p>
              </div>
              <div className="description">{children}</div>
            </div>
          </div>

          <div className="bottom">
            {errorCode && <p className="code">{errorCode}</p>}
            {onClick && (
              <div className="btn-wrap">
                <Button
                  width="100%"
                  color="primary"
                  type="solid"
                  size="large"
                  label={buttonTitle}
                  onClick={onClick}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </StyledError>
  );
};
